import {
  ApolloClient,
  ApolloProvider,
  createHttpLink,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

let uri = "/graphql";
export let imageURL = "/api/menu-item-image";
export let uploadMenuItemImageURL = "/api/upload-menu-item-image";
if (process.env.NODE_ENV === "development") {
  uri = "http://localhost:3000/graphql";
  imageURL = "http://localhost:3000/api/menu-item-image";
  uploadMenuItemImageURL = "http://localhost:3000/api/upload-menu-item-image";
}

const httpLink = createHttpLink({
  uri,
  credentials: "include", // 🔥 Allow cookies to be sent with requests
});

const authLink = setContext((_, { headers }: any) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

// const client = new ApolloClient({
//   uri,
//   cache: new InMemoryCache(),
//   credentials: "include",
// });
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <App />
    </ApolloProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
